// Helpers for persisting personalization data across sessions

export interface PersistedPersonalization {
  childName: string;
  inputAge: string;
  childgender: string;
  inputDedication: string;
  inputCover: any;
  inputPackaging?: boolean;
  imageSelected: string;
  croppedImageBase64?: string;
  isFirstProductAdded?: boolean;
  timestamp: number;
}

export const savePersonalization = (data: Omit<PersistedPersonalization, 'timestamp'>) => {
  try {
    const { croppedImageBase64, ...rest } = data as any;
    const serializable: PersistedPersonalization = { ...rest, croppedImageBase64, timestamp: Date.now() };
    const existing = loadPersonalizationArray();
    const idx = existing.findIndex((item) => item.childName === data.childName);
    const next =
      idx !== -1
        ? existing.map((item, i) => (i === idx ? serializable : item))
        : [...existing, serializable];
    localStorage.setItem('userPersonalizationDataArray', JSON.stringify(next));
  } catch (e) {
    console.error('Error saving personalization:', e);
  }
};

export const loadPersonalizationArray = (): PersistedPersonalization[] => {
  try {
    const raw = localStorage.getItem('userPersonalizationDataArray');
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const base64ToFile = async (
  base64: string,
  filename: string,
  mimeType = 'image/jpeg'
): Promise<File | null> => {
  try {
    if (base64.startsWith('blob:')) {
      const res = await fetch(base64);
      const blob = await res.blob();
      return new File([blob], filename, { type: mimeType });
    }
    let data = base64;
    if (base64.startsWith('data:')) {
      const parts = base64.split(',');
      data = parts[1];
      const match = parts[0].match(/:(.*?);/);
      if (match) mimeType = match[1];
    }
    const bytes = atob(data);
    const ab = new ArrayBuffer(bytes.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < bytes.length; i++) ia[i] = bytes.charCodeAt(i);
    return new File([ab], filename, { type: mimeType });
  } catch {
    return null;
  }
};
